"use client";

import { c as _c } from "react/compiler-runtime";
import React, { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import SmallScreenHeader from "./SmallScreenHeader";
import WebSidebar from "./sidebar/WebSidebar";
import { SIDEBAR_WIDTHS } from "../../constants/sidebar";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import { useSearchParams } from "next/navigation";
import { SidebarProvider } from "../../hooks/useSidebarState";
import ClientOnly from "../client-only/ClientOnly";
import { useHeaderContext } from "@/contexts/HeaderContext";
interface Props {
  readonly children: ReactNode;
}
export default function SmallScreenLayout(t0) {
  const $ = _c(29);
  const {
    children
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    registerRef
  } = useLayout();
  const {
    setHeaderRef
  } = useHeaderContext();
  const containerRef = useRef(null);
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("tab") || "latest";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeTab = t1;
  let t2;
  if ($[2] !== registerRef || $[3] !== setHeaderRef) {
    t2 = node => {
      registerRef("header", node);
      setHeaderRef(node);
    };
    $[2] = registerRef;
    $[3] = setHeaderRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const headerWrapperRef = t2;
  let t3;
  let t4;
  if ($[5] !== registerRef || $[6] !== setHeaderRef) {
    t3 = () => () => {
      registerRef("header", null);
      setHeaderRef(null);
    };
    t4 = [registerRef, setHeaderRef];
    $[5] = registerRef;
    $[6] = setHeaderRef;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] !== activeTab) {
    t5 = () => {
      const container = containerRef.current;
      if (container && activeTab) {
        requestAnimationFrame(() => {
          container.scrollTop = 0;
        });
      }
    };
    t6 = [activeTab];
    $[9] = activeTab;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsMenuOpen(_temp);
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const toggleMenu = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsMenuOpen(false);
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const closeMenu = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tailwind-scope tw-min-h-[100dvh] tw-bg-black tw-flex tw-items-center tw-justify-center tw-px-6"><div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-8 tw-text-center md:tw-text-left"><img src="https://d3lqz0a4bldqgf.cloudfront.net/images/scaled_x450/0x33FD426905F149f8376e227d0C9D3340AaD17aF1/279.WEBP" alt="Brain" className="tw-rounded-md tw-shadow-lg tw-max-w-[40vw] md:tw-max-w-[180px] tw-h-auto" width={220} height={326} loading="eager" /><h1 className="tw-text-xl tw-font-bold tw-text-white">Loading...</h1></div></div>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = `tw-bg-black ${activeTab === "feed" ? "tw-overflow-hidden" : "tw-overflow-auto"}`;
  let t11;
  if ($[15] !== isMenuOpen) {
    t11 = <SmallScreenHeader onMenuToggle={toggleMenu} isMenuOpen={isMenuOpen} />;
    $[15] = isMenuOpen;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== headerWrapperRef || $[18] !== t11) {
    t12 = <div ref={headerWrapperRef}>{t11}</div>;
    $[17] = headerWrapperRef;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isMenuOpen) {
    t13 = <div className="tailwind-scope"><WebSidebar isCollapsed={false} onToggle={toggleMenu} isMobile={true} isOffcanvasOpen={isMenuOpen} onCloseOffcanvas={closeMenu} sidebarWidth={SIDEBAR_WIDTHS.EXPANDED} /></div>;
    $[20] = isMenuOpen;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== children) {
    t14 = <main className="tw-transition-opacity tw-duration-300">{children}</main>;
    $[22] = children;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
    t15 = <SidebarProvider><ClientOnly fallback={t9}><div ref={containerRef} className={t10}>{t12}{t13}{t14}</div></ClientOnly></SidebarProvider>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
}
function _temp(prev) {
  return !prev;
}